export const subscriptionPlans = {
  plus: {
    name: 'subscription.plans.plus.name',
    title: 'subscription.plans.plus.title',
    prices: [
      { duration: 1, price: '3000', key: 'subscription.duration.oneMonth',id:'plus1' },
      { duration: 3, price: '8000', key: 'subscription.duration.threeMonths',id:'plus3' },
      { duration: 6, price: '13000', key: 'subscription.duration.sixMonths',id:'plus6' }
    ],
    features: [
      { key: 'subscription.plans.plus.features.unlimitedLikes', included: true },
      { key: 'subscription.plans.plus.features.seeWhoLikesYou', included: false },
      { key: 'subscription.plans.plus.features.priorityLikes', included: false },
      { key: 'subscription.plans.plus.features.unlimitedRewinds', included: true },
      { key: 'subscription.plans.plus.features.freeInvitations', included: false },
      { key: 'subscription.plans.plus.features.acceptInvitations', included: false },
      { key: 'subscription.plans.plus.features.messageBeforeMatch', included: false },
      { key: 'subscription.plans.plus.features.passport', included: true },
      { key: 'subscription.plans.plus.features.topPicks', included: false }
    ],
    description: 'subscription.plans.plus.description'
  },
  gold: {
    name: 'subscription.plans.gold.name',
    title: 'subscription.plans.gold.title',
    prices: [
      { duration: 1, price: '5000', key: 'subscription.duration.oneMonth',id:'gold1' },
      { duration: 3, price: '13000', key: 'subscription.duration.threeMonths',id:'gold3' },
      { duration: 6, price: '20000', key: 'subscription.duration.sixMonths',id:'gold6' }
    ],
    features: [
      { key: 'subscription.plans.gold.features.unlimitedLikes', included: true },
      { key: 'subscription.plans.gold.features.seeWhoLikesYou', included: true },
      { key: 'subscription.plans.gold.features.priorityLikes', included: false },
      { key: 'subscription.plans.gold.features.unlimitedRewinds', included: true },
      { key: 'subscription.plans.gold.features.freeInvitations', included: true },
      { key: 'subscription.plans.gold.features.acceptInvitations', included: true },
      { key: 'subscription.plans.gold.features.messageBeforeMatch', included: false },
      { key: 'subscription.plans.gold.features.passport', included: true },
      { key: 'subscription.plans.gold.features.topPicks', included: true }
    ],
    description: 'subscription.plans.gold.description'
  },
  platinum: {
    name: 'subscription.plans.platinum.name',
    title: 'subscription.plans.platinum.title',
    prices: [
      { duration: 1, price: '10000', key: 'subscription.duration.oneMonth',id:'platinum1' },
      { duration: 3, price: '25000', key: 'subscription.duration.threeMonths',id:'platinum3' },
      { duration: 6, price: '45000', key: 'subscription.duration.sixMonths',id:'platinum6' }
    ],
    features: [
      { key: 'subscription.plans.platinum.features.unlimitedLikes', included: true },
      { key: 'subscription.plans.platinum.features.seeWhoLikesYou', included: true },
      { key: 'subscription.plans.platinum.features.priorityLikes', included: true },
      { key: 'subscription.plans.platinum.features.unlimitedRewinds', included: true },
      { key: 'subscription.plans.platinum.features.freeInvitations', included: true },
      { key: 'subscription.plans.platinum.features.acceptInvitations', included: true },
      { key: 'subscription.plans.platinum.features.messageBeforeMatch', included: true },
      { key: 'subscription.plans.platinum.features.passport', included: true },
      { key: 'subscription.plans.platinum.features.topPicks', included: true }
    ],
    description: 'subscription.plans.platinum.description'
  }
};

export default subscriptionPlans;
